import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Closure from '../pages/Closure';
import Transaction from '../pages/Transaction';
import Sale from '../pages/Sale';
import { useRouteMatch } from 'react-router';

const PosRouter = () => {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={Dashboard} />
      <Route exact path={`${path}/closure`} component={Closure} />
      <Route path={`${path}/transaction/:id`} component={Transaction} />
      <Route path={`${path}/sale`} component={Sale} exact />
      <Route path={`${path}/sale/:id`} component={Sale} />
    </Switch>
  );
};

export default PosRouter;
